import * as catalogos from './catalogos/es';
export const locale = {
    lang: 'es',
    data: {
      'SECCIONES': {
        'NOTATITULO':'Nota: ',
        'RANGOS':{
          '1':'Nulo',
          '2':'Bajo',
          '3':'Medio',
          '4':'Alto',
          '5':'Muy alto',
        },
        'EXCEL':{
          'RESULTS':'Resultados NOM035_STP_2018 ',
          'DESCARG_EXCEL':'Descargando excel',
        },
        'MENU' :{
          'INTRODUCCION':'Introducción',
          'GENERALES':'Generales',
          'NO_RESPONDIERON': 'No respondieron',
          'ACONTECIMIENTOS_TRAUMATICOS': 'Acontecimientos traumáticos',
          'AT_RESPUESTAS_ENCUESTA':'Respuestas de la encuesta',
          'SUFRIERON_ACONTECIMIENTO_TRAUMATICO': 'Presenciaron o sufrieron un acontecimiento',
          'REQUIEREN_ATENCION_CLINICA': 'Requieren atención clínica',
          'FRP': 'Factores de riesgo psicosocial',
          'FR_RESPUESTAS_ENCUESTA':'Respuestas de la encuesta',
          'RESPUESTAS_INDIVIDUALES':'Resultados individuales',
          'TABLEROS': 'Tableros',
          'TABLERO_GLOBAL': 'Global',
          'TABLERO_CATEGORIA':'Por categoría',
          'TABLERO_DOMINIO': 'Por dominio',
          'CALIFICACIONFINAL': 'Calificación final'
        },

        'PRINCIPAL' :{
          'BUSCADOR':'Buscar centro de trabajo',
          'CT':'Centro de trabajo',
          'DIRECCION': 'Dirección',
          'TIPOCONTRATACION':'Tipo de centro de trabajo',
          'ACCIONES': 'Acciones',
          'BOTONRESULTADOS': 'Ver resultados',
          'DESBOTONRESULTADOS': 'Descargar resultados',
          'MAS_50':'Más de 50',
          'MENOS_50':'Menos de 50',
          'PLACE':'Ingrese el nombre del centro de trabajo'
        },

        'INTRODUCCION' :{
          'TITULO':'RESULTADOS DE LA NOM-035-STPS-2018',
        },

        'GENERALES' :{
          'TITULO':'Información general',
          'EMPRESA':'Empresa: ',
          'CT':'Centro de trabajo: ',
          'DOMICILIO':'Domicilio: ',
          'ACTIVIDAD_P':'Actividad principal: ',
          'OBJETIVO':'Objetivo: ',
          'P_ACTIVIDADESREALIZADAS':'Principales actividades realizadas: ',
          'TOTAL_COLABORADORES':'Total de colaboradores: ',
          'FECHA_APLICACION':'Fecha de aplicación: ',
          'TOTAL_ENCUESTADOS':'Total de encuestados: ',
          'COLABORADORES_NOACEPTARON':'Colaboradores que no aceptaron responder encuesta: ',
          'COLABORADORES_SUJETOS_ATS':'Colaboradores sujetos a acontecimientos traumáticos severos que requieren atención: ',
          'PORCENTAJE_PARTICIPACION':'Porcentaje de participación',
          'PORCENTAJE_NOPARTICIPACION':'Porcentaje de no participación',
          'PERSONAS':' Personas',
        },

        'NO_RESPONDIERON' :{
          'TITULO':'Colaboradores que no aceptaron responder la encuesta',
          'NOMBRE':'Nombre del colaborador',
          'MENSAJE':'Todos sus colaboradores han aceptado responder la encuesta'
        },

        'AT_RESPUESTAS_ENCUESTA' :{
          'TITULO':'Respuestas de la encuesta para identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos',
          'PREGUNTA':'Pregunta',
          'RESPUESTA':'Respuesta',
          'SI':'Si',
          'NO':'No'
        },

        'SUFRIERON_ACONTECIMIENTO_TRAUMATICO' :{
          'TITULO':'Colaboradores que presenciaron o sufrieron alguna vez, durante o con motivo del trabajo un acontecimiento traumático',
          'NOMBRE_COLABORADOR':'Nombre del colaborador',
          'MENSAJE':'Ningún colaborador ha presenciado o sufrido alguna vez, durante o con motivo del trabajo un acontecimiento traumático'
        },

        'REQUIEREN_ATENCION_CLINICA' :{
          'TITULO':'Colaboradores que sufrieron un acontecimiento traumático severo y requieren atención clínica',
          'NOMBRE_COLABORADOR':'Nombre del colaborador',
          'MENSAJE':'Ningún colaborador ha sufrido un acontecimiento traumático severo y por ende ninguno requiere atención clínica'
        },

        'FR_RESPUESTAS_ENCUESTA' :{
          'TITULO-50':'Respuestas del cuestionario para identificar los factores de riesgo psicosocial en los centros de trabajo',
          'TITULO2+50':'Respuestas del cuestionario para identificar los factores de riesgo psicosocial y evaluar el entorno organizacional en los centros de trabajo',
          'PREGUNTA':'Pregunta',
          'SIEMPRE':'Siempre',
          'CASI_SIEMPRE':'Casi siempre',
          'ALGUNAS_VECES':'Algunas veces',
          'CASI_NUNCA':'Casi nunca',
          'NUNCA':'Nunca'
        },

        'RESPUESTAS_INDIVIDUALES' :{
          'TITULO-50':'Respuestas individuales de la encuestapara identificar los factores de riesgo psicosocial en los centros de trabajo',
          'TITULO2+50':'Respuestas individuales de la encuesta para identificar los factores de riesgo psicosocial y evaluar el entorno organizacional en los centros de trabajo',
          'NOMBRE_COLABORADOR':'Nombre del colaborador'
        },

        'TABLERO_GLOBAL' :{
          'TITULO':'Tablero de resultados por categoría, dominio y dimensión',
          'CATEGORIA':'Categoría',
          'DOMINIO':'Dominio',
          'DIMENSION':'Dimensión',
          'NOTA':'Los números de las categorías y dominios son el promedio de las respuestas de sus dimensiones.'
        },

        'TABLERO_CATEGORIA' :{
          'TITULO':'Tablero de resultados por categoría',
          'CATEGORIA':'Categoría',
          'NOTA':'Los números de las categorías son el promedio de las respuestas de las dimensiones de su dominio.',
          'LABEL':'Resultados por categoría'
        },

        'TABLERO_DOMINIO' :{
          'TITULO':'Tablero de resultados por dominio',
          'DOMINIO':'Dominio',
          'NOTA':'Los números de los dominios son el promedio de las respuestas de sus dimensiones.',
          'LABEL':'Resultados por dominio'
        },
            'CALIFICACIONFINAL' :{
              'TITULO':'Calificación final',
              'NOTA':'La calificación final es el promedio de la suma de todas las preguntas de la encuesta.',
              'TEXTOCALIFICACION': catalogos.textoCalificacion,
            }

        }
      }
};
